import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import CTA from "@/components/CTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FAQ from "@/components/FAQ";
import Partners from "@/components/Partners";

function App() {
  return (
    <main className="min-h-screen bg-background text-foreground antialiased selection:bg-neon selection:text-black font-sans">
      <Navbar />
      <Hero />
      <Partners />
      <About />
      <Services />
      <Projects />
      <CTA />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}

export default App;
